import Currency from 'app/shared-components/util/Currency';
import { useTranslation } from 'react-i18next';
import { HighnoteTransactionEvent, HighnoteTransactionStatus } from 'API';
import { Box, Card, CardContent, Typography, useTheme } from '@mui/material';

interface MobileTransactionItemProps {
  transaction: Partial<HighnoteTransactionEvent>;
  onTransactionClick: (transactionId: string) => void;
}

const MobileTransactionItem = ({ transaction, onTransactionClick }: MobileTransactionItemProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isTransactionPending = transaction?.status === HighnoteTransactionStatus.APPROVED;

  // Figma 5518:111584 — row uses size+color for hierarchy, both rows Medium (not bold).
  const topTextSx = {
    fontSize: '1.1rem',
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '0.5px',
    color: 'neutral50.main',
  };
  const bottomTextSx = {
    fontSize: '1.6rem',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: '#3b3b3e',
  };

  return (
    <Card
      elevation={0}
      onClick={() => transaction.id && onTransactionClick(transaction.id)}
      sx={{
        cursor: 'pointer',
        borderRadius: 0,
        bgcolor: 'transparent',
        borderBottom: '1px solid',
        borderColor: 'divider',
        '&:last-of-type': { borderBottom: 'none' },
        '&:hover': { bgcolor: theme.palette.action.hover },
      }}
    >
      <CardContent sx={{ p: 2, pb: '16px !important' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', pb: 0.5 }}>
          {/* Date */}
          <Typography sx={topTextSx}>
            {isTransactionPending ? t('pending') : new Date(transaction.eventDate || '').toLocaleDateString()}
          </Typography>

          {/* Category */}
          <Typography sx={topTextSx}>{transaction.merchantCategory}</Typography>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          {/* Merchant Name */}
          <Typography sx={bottomTextSx}>{transaction.merchantName}</Typography>

          {/* Amount */}
          <Typography sx={bottomTextSx}>
            <Currency
              value={transaction?.approvedAmount?.value || 0}
              currency={transaction?.approvedAmount?.currencyCode || 'USD'}
            />
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default MobileTransactionItem;
